import React, { useState, useEffect } from 'react';
// import { useLanguage } from '../../../../../store/languageContext';
// import { LanguageFactory } from '../../../../../factories';
import { Tabs, Card, Row, Col, Button, Form, Select, message } from 'antd';
import Input from '../../../../ui/Input';
import TextArea from '../../../../ui/TextArea';
import PageContainer from '../../../../CSIComponents/PageContainer';
import { addOtherPolicy } from '../../../../../services/policy';
import Loading from '../../../../Loading';
import commonStyles from './../../../../CSIComponents/index.module.css';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';

interface propsTypes {
  otherPoliciesDetails: any;
  isEditable: void | any;
  cancelEditable: void | any;
  supplier: string;
  propertyId: string;
  changeTab: void | any;
  getPoliciesData: any;
  setPoliciesData: void | any;
  setOtherPoliciesDetails: void | any;
}

const policyName = [
  'Family/Children',
  'GeneralPolicy',
  'GroupConditions',
  'OversoldOther',
  'OversoldPayPhoneCall',
  'OversoldAltHotel',
  'OversoldPayTransportation',
  'OversoldPayRoom',
];
const FormItem = Form.Item;
const Option = Select.Option;
const TabPane = Tabs.TabPane;
const OtherPoliciesEdit = (props: propsTypes) => {
  // const { language } = useLanguage()
  // const lang = new LanguageFactory(language)
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [disableFlag, setDisableFlag] = useState(false);
  const [form] = Form.useForm();
  const addOtherPolicies = () => {
    form
      .validateFields()
      .then((values) => {
        setLoadingFlag(true);
        const requestBody = {
          supplier: props.supplier,
          propertyId: props.propertyId,
          property: {
            policies: {
              otherpolicy: [
                {
                  description: values.description,
                  name: values.name,
                },
              ],
            },
          },
        };

        addOtherPolicy(requestBody).then(
          (res) => {
            if (res.result.success) {
              setLoadingFlag(false);
              props.cancelEditable();
              props.setOtherPoliciesDetails(values);
              //props.setPoliciesData({})
              props.getPoliciesData('OtherPolicies');
            } else {
              setLoadingFlag(false);
              message.error({
                content: res?.error[0]?.message || 'operation failed',
              });
            }
          },
          (err) => {
            message.error({
              content: err?.message || err?.error[0]?.message,
            });
            setLoadingFlag(false);
            props.cancelEditable();
            // props.setPoliciesData({})
            // props.getPoliciesData('OtherPolicies')
          }
        );
      })
      .catch((errorInfo) => {
        // message.error({
        //     content: 'Check all the fields please.',
        // });
      });
  };

  const validateForm = () => {
    form
      .validateFields()
      .then(() => {
        setDisableFlag(false);
      })
      .catch((err) => {
        err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false);
      });
  };

  useEffect(
    validateForm,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <>
      <Tabs defaultActiveKey="detail">
        <TabPane
          tab="Detail"
          key="detail"
        >
          <PageContainer>
            <Card
              style={{ marginTop: -15 }}
              title={props?.otherPoliciesDetails?.name}
            >
              <div style={{ padding: '0 20px' }}>
                <Form
                  onValuesChange={validateForm}
                  form={form}
                  layout="vertical"
                >
                  <FormItem
                    name="otherpolicyid"
                    style={{ display: 'none' }}
                  >
                    <Input />
                  </FormItem>
                  <FormItem
                    name="otherpolicylangid"
                    style={{ display: 'none' }}
                  >
                    <Input />
                  </FormItem>
                  <Row gutter={24}>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="name"
                        label="Policy Name"
                        rules={[
                          {
                            required: true,
                            message: 'This field is required',
                          },
                        ]}
                      >
                        <Select allowClear showSearch>
                          {policyName.map((item) => (
                            <Option value={item}>{item}</Option>
                          ))}
                        </Select>
                      </FormItem>
                    </Col>
                    <Col
                      span={12}
                      className="col-margin"
                    ></Col>
                    <Col
                      span={18}
                      className="col-margin"
                    >
                      <FormItem
                        name="description"
                        label="Description"
                        rules={[
                          {
                            required: true,
                            message: 'This field is required',
                          },
                          {
                            max: 2000,
                            message:
                              'You have reached the max character length of 2000',
                          },
                        ]}
                      >
                        <TextArea
                          maxLength={2000}
                          minRows={3}
                        />
                      </FormItem>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Card>
          </PageContainer>
        </TabPane>
      </Tabs>
      <ActionButtonsBar
        onCancel={() => {
          props.cancelEditable();
          props.changeTab('OtherPolicies');
        }}
        onSave={addOtherPolicies}
        disabledSave={disableFlag}
      />
      {loadingFlag && (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
          }}
        >
          <Loading type="large" />
        </div>
      )}
    </>
  );
};

export default OtherPoliciesEdit;
